<template>
  <div class="period-selector">
    <div class="d-flex align-center flex-wrap" style="gap: 8px;">
      <v-btn-toggle v-model="activePreset" mandatory dense class="period-presets">
        <v-btn v-for="p in presets" :key="p.key" :value="p.key" small depressed class="text-none">
          {{ p.label }}
        </v-btn>
      </v-btn-toggle>
      <template v-if="activePreset === 'custom'">
        <v-text-field v-model="customFrom" label="Desde" outlined dense type="date" hide-details class="date-input ml-2"></v-text-field>
        <v-text-field v-model="customTo" label="Hasta" outlined dense type="date" hide-details class="date-input ml-1"></v-text-field>
      </template>
      <v-btn color="primary" @click="emitPeriod" :loading="loading" depressed small class="ml-1">
        <v-icon left small>mdi-refresh</v-icon> Actualizar
      </v-btn>
    </div>
    <div v-if="compareLabel" class="text-caption grey--text mt-1">vs {{ compareLabel }}</div>
  </div>
</template>

<script>
export default {
  name: "PeriodSelector",
  props: {
    loading: { type: Boolean, default: false },
    defaultPreset: { type: String, default: "30d" }
  },
  data() {
    return {
      activePreset: this.defaultPreset,
      customFrom: this.daysAgo(30),
      customTo: this.today(),
      presets: [
        { key: "today", label: "Hoy" },
        { key: "yesterday", label: "Ayer" },
        { key: "7d", label: "7 días" },
        { key: "30d", label: "30 días" },
        { key: "this_month", label: "Este Mes" },
        { key: "last_month", label: "Mes Anterior" },
        { key: "custom", label: "Custom" },
      ],
    };
  },
  computed: {
    period() {
      return this.calcPeriod(this.activePreset);
    },
    compareLabel() {
      const p = this.period;
      if (!p) return "";
      if (this.activePreset === "today") return "ayer";
      if (this.activePreset === "yesterday") return "anteayer";
      if (this.activePreset === "7d") return "7d anteriores";
      if (this.activePreset === "30d") return "30d anteriores";
      if (this.activePreset === "this_month") return "mismo periodo mes anterior";
      if (this.activePreset === "last_month") return "mes ante-anterior";
      const days = this.daysBetween(p.dateFrom, p.dateTo) + 1;
      return `${days}d anteriores`;
    },
  },
  watch: {
    activePreset() {
      if (this.activePreset !== "custom") {
        this.emitPeriod();
      }
    },
  },
  mounted() {
    this.emitPeriod();
  },
  methods: {
    today() {
      return new Date().toISOString().substr(0, 10);
    },
    daysAgo(n) {
      return new Date(Date.now() - n * 86400000).toISOString().substr(0, 10);
    },
    daysBetween(from, to) {
      return Math.round((new Date(to) - new Date(from)) / 86400000);
    },
    calcPeriod(preset) {
      const today = this.today();
      let dateFrom, dateTo, compareDateFrom, compareDateTo;

      switch (preset) {
        case "today":
          dateFrom = dateTo = today;
          compareDateFrom = compareDateTo = this.daysAgo(1);
          break;
        case "yesterday": {
          const y = this.daysAgo(1);
          dateFrom = dateTo = y;
          compareDateFrom = compareDateTo = this.daysAgo(2);
          break;
        }
        case "7d":
          dateFrom = this.daysAgo(6);
          dateTo = today;
          compareDateFrom = this.daysAgo(13);
          compareDateTo = this.daysAgo(7);
          break;
        case "30d":
          dateFrom = this.daysAgo(29);
          dateTo = today;
          compareDateFrom = this.daysAgo(59);
          compareDateTo = this.daysAgo(30);
          break;
        case "this_month": {
          const d = new Date();
          dateFrom = new Date(d.getFullYear(), d.getMonth(), 1).toISOString().substr(0, 10);
          dateTo = today;
          const dayOfMonth = d.getDate();
          const prevMonth = new Date(d.getFullYear(), d.getMonth() - 1, 1);
          compareDateFrom = prevMonth.toISOString().substr(0, 10);
          compareDateTo = new Date(prevMonth.getFullYear(), prevMonth.getMonth(), dayOfMonth).toISOString().substr(0, 10);
          break;
        }
        case "last_month": {
          const d2 = new Date();
          const firstPrev = new Date(d2.getFullYear(), d2.getMonth() - 1, 1);
          const lastPrev = new Date(d2.getFullYear(), d2.getMonth(), 0);
          dateFrom = firstPrev.toISOString().substr(0, 10);
          dateTo = lastPrev.toISOString().substr(0, 10);
          const firstPrev2 = new Date(d2.getFullYear(), d2.getMonth() - 2, 1);
          const lastPrev2 = new Date(d2.getFullYear(), d2.getMonth() - 1, 0);
          compareDateFrom = firstPrev2.toISOString().substr(0, 10);
          compareDateTo = lastPrev2.toISOString().substr(0, 10);
          break;
        }
        case "custom":
        default: {
          dateFrom = this.customFrom;
          dateTo = this.customTo;
          const span = this.daysBetween(dateFrom, dateTo);
          compareDateTo = new Date(new Date(dateFrom).getTime() - 86400000).toISOString().substr(0, 10);
          compareDateFrom = new Date(new Date(compareDateTo).getTime() - span * 86400000).toISOString().substr(0, 10);
          break;
        }
      }

      return { dateFrom, dateTo, compareDateFrom, compareDateTo, preset };
    },
    emitPeriod() {
      this.$emit("change", this.period);
    },
  },
};
</script>

<style scoped>
.period-selector { width: 100%; }
.period-presets { flex-wrap: wrap; }
.period-presets .v-btn { font-size: 0.75rem; letter-spacing: 0; min-width: 0; padding: 0 8px; }
.date-input { max-width: 160px; min-width: 130px; }
@media (max-width: 600px) {
  .period-presets .v-btn { font-size: 0.6875rem; padding: 0 6px; }
  .date-input { max-width: 140px; }
}
</style>
